import React, { Component } from "react";
import { Table, Button, Col, Tooltip, Row, Modal, DatePicker } from "antd";
import axios from "axios";
import "./Pages.css";
import InventarioForm from '../components/InventarioForm';
import CaixaPrintModal from "../relatorios/CaixaPrintModal";
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import InputForm from "../components/InputForm";
import { maskDate } from "../utils/Masker";
import AjusteEstoque from '../tutoriais/LancAjusteEstoque';

const { Column } = Table;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    formVisivel: false,

    filtros: {
      tipoTela: 'IN',
      buscaDataIni: moment().format('DD/MM/YYYY'),
      buscaDataFim: moment().format('DD/MM/YYYY'),
    }
  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }


  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { pagina, limite } = this.state;
    const { buscaDataIni } = this.state.filtros;

    if (buscaDataIni) {
      let dataIni = '';
      if ((buscaDataIni) && (buscaDataIni !== undefined)) {
        dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      axios
        .get('/estoque/listaInventario', {
          params: {
            page: pagina,
            limite: limite,
            dataIni,
          }
        })
        .then(response => {
          const { data, total, current_page, per_page } = response.data;
          this.setState({
            listaRegistros: data,
            carregando: false,
            total: total,
            pagina: current_page,
            limite: Number(per_page),
          });

        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });
    } else {
      this.setState({
        listaRegistros: [],
        carregando: false,
      });
    }
  };


  onInventarioClick = () => {
    this.setState({
      formVisivel: false,
    },
      this.getListaRegistros
    )
  };

  onCancelarInventarioClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onNovoInventarioClick = registro => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {
        mi_ent_sai: '',
        mi_item: { key: '0' },
        mi_item_tamanho: 0,
        mi_item_cor: 0,
        mi_qtde: 0,
        mi_qtde_dif: 0,
        mi_vlr_unit: 0,
        mi_vlr_total: 0,
      }
    })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/estoque/deleteInventario/${registro.mi_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.mi_idf === registro.mi_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            if (error.response.status === 412) {
              Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
            } else {
              Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
            }
          })
      }
    })
  };


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { filtros } = this.state;
    filtros[id] = value;
    this.setState({
      [id]: value
    },
      this.getListaRegistros
    );
  };

  onDateChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { filtros } = this.state;
    filtros['buscaDataIni'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({
      buscaDataIni: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'))
    }, this.getListaRegistros);
  }



  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }

  renderAcoes = (text, registro) => {
    return (
      <Tooltip title="Excluir">
        <Button type="danger" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
      </Tooltip>
    );
  };

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderDescricao = (prod_descricao, registro) => {
    return (
      <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
    );
  };

  renderTipoMov = (mi_tipo_mov) => {
    return (
      <span> {mi_tipo_mov === 'E' ? 'ENTRADA' : 'SAÍDA'} </span>
    );
  };

  renderDescrProduto = (prod_descricao, registro) => {
    return (
      <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
    );
  };

  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, total, pagina, limite, } = this.state;
    const { buscaDataIni, buscaDataFim } = this.state.filtros;

    // console.log('InventarioPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">Ajuste do Estoque - Inventário</span>
          <Tooltip title="Ajuda">
            <Button
              type="primary"
              onClick={() => this.setState({ modalOpen: true })}
              icon="question"
              className="botao-ajuda"
            ></Button>
          </Tooltip>
        </div>
        <div className="divider-page" />

        <Row>
          <div className="pageFiltro" style={{ height: 20 }}>
            <Col xs={24} >

              <Row xs={24} style={{}}>
                <Col xs={11} style={{ width: 200, marginRight: 10 }}>
                  <span>Data</span>
                  <DatePicker
                    onChange={this.onDateChange}
                    format="DD/MM/YYYY"
                    showToday={true}
                    allowClear={false}
                    value={moment(buscaDataIni, "DD/MM/YYYY", true)}
                    style={{ width: "100%" }}
                  />
                </Col>

                {/* <Col xs={2} style={{ width: 110, marginTop: 20 }}>
                  <CaixaPrintModal
                    filtros={filtros}
                    situacaoCaixa={this.state.situacaoCaixa}
                    vlrInicial={this.state.vlrInicial}
                    vlrCred={this.state.vlrCred}
                    vlrDeb={this.state.vlrDeb}
                    vlrFinal={this.state.vlrFinal}
                    ctaCorrente={this.state.filtros.buscaCtaCorrente}
                    periodo={this.state.filtros.buscaDataIni + ' a ' + this.state.filtros.buscaDataFim}
                  />
                </Col> */}

                {getTemPermissao('InventarioPage', 'novo') ? (
                  <Col xs={2} style={{ width: 110, marginTop: 20 }}>
                    <Button
                      type="primary"
                      onClick={this.onNovoInventarioClick}
                      className="botao-primary"
                      style={{ marginRight: 15, width: 120 }}
                    >
                      Novo Ajuste
                    </Button>
                  </Col>
                ) : null}

              </Row>

            </Col>

            <InventarioForm
              visivel={formVisivel}
              onInventarioClick={this.onInventarioClick}
              onCancelarInventarioClick={this.onCancelarInventarioClick}
            />

            <AjusteEstoque
              isOpen={this.state.modalOpen}
              onClose={() => this.setState({ modalOpen: false })}
            />
          </div>
        </Row>

        <Row>
          <div style={{ marginTop: 10 }}>
            <Table
              pagination={{
                total: total,
                pageSize: limite,
                current: pagina,
                pageSizeOptions: ['10', '20', '30', '40'],
                showSizeChanger: true,
              }}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.mi_idf)}
            >
              <Column
                key="prod_codigo"
                dataIndex="prod_codigo"
                title="Produto"
                width={80}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="prod_descricao"
                dataIndex="prod_descricao"
                title="Descrição Produto"
                render={this.renderDescrProduto}
                width={300}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="mi_ent_sai"
                dataIndex="mi_ent_sai"
                title="Tipo Mov."
                render={this.renderTipoMov}
                width={60}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="mi_qtde"
                dataIndex="mi_qtde"
                title="Qtde"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="mi_vlr_unit"
                dataIndex="mi_vlr_unit"
                title="Vlr Unit"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="mi_vlr_total"
                dataIndex="mi_vlr_total"
                title="Vlr Total"
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="acoes"
                title=""
                render={this.renderAcoes}
                width={40}
                align="center"
                className="listaCadastro"
              />
            </Table>
          </div>
        </Row>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/InventarioPage.js